import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {fetchUserProfile} from "../services/authApi";

export const useProfile = () => {
  const [profile, setProfile] = useState({
    name: '',
    email: '',
    image: '',
    initial: ''
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const loadProfile = async () => {
      const token = localStorage.getItem('cookies');
      if (!token) {
        navigate('/login');
        return;
      }
      try {
        setLoading(true);
        const data = await fetchUserProfile();
        const user = data.data;
        setProfile({
          name: user.name,
          email: user.email,
          image: data.image || ' ',
          initial: user.name.charAt(0).toUpperCase(),
        });
      } catch (error) {
        console.error('Failed to load profile:', error);
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, [navigate]);

  return { profile, error, loading };
};